/* eslint-disable camelcase */
/* eslint-disable no-use-before-define */
import i18n from 'i18next';

import { usersService } from '@services';
import * as commonActions from '@store/common/actions';
import * as loggedActions from '@store/logged/actions';
import { routerActions } from 'connected-react-router';
import { MSJ_ERROR_EMAIL_AGE } from '@constants/email';
import { USERS, USER_DETAIL, USER_INVITE_FORM } from '@constants/routes';
import { successResponsive } from '@constants/errorObjects';
import { showError } from '@store/logged/actions';
import { parsePhoneObject } from '@helpers/utils';
import * as actionTypes from './actionTypes';

export const getUsers = () => (dispatch) => {
  dispatch(commonActions.showLoading());
  usersService
    .getUsers()
    .then((users) => {
      dispatch(getUserSuccess(users));
    })
    .catch((error) => {
      dispatch(getUserError(error));
    })
    .finally(() => dispatch(commonActions.hideLoading()));
};
export const getUser = (id) => (dispatch) => {
  dispatch(showLoading());
  usersService
    .getUser(id)
    .then((user) => {
      dispatch(getUserSuccess(user));
    })
    .catch((error) => {
      dispatch(getUserError(error));
    });
};

export const blockUser = (user, action, usersList) => (dispatch) => {
  dispatch(commonActions.showLoading());
  usersService
    .setUserState(user, action)
    .then(() => {
      dispatch(
        showError(
          successResponsive(
            action === 'UNSUBSCRIBE'
              ? i18n.t('users.actions.userBlocked')
              : i18n.t('users.actions.userUnblocked')
          )
        )
      );
      const newUsersList = usersList.map((newUser) => {
        if (newUser._id === user._id && action === 'UNSUBSCRIBE') {
          newUser.status = action;
        } else if (newUser._id === user._id) {
          newUser.status = 'APPROVED';
        }
        return newUser;
      });
      dispatch(getUserSuccess(newUsersList));
    })
    .catch((error) => dispatch(showError(error)))
    .finally(() => dispatch(commonActions.hideLoading()));
};

export const deleteUser = (user, action, usersList) => (dispatch) => {
  dispatch(commonActions.showLoading());
  usersService
    .deleteUser(user, action)
    .then(() => {
      dispatch(showError(successResponsive(i18n.t('users.actions.userDeleted'))));
      const newUsersList = usersList.map((newUser) => {
        if (newUser._id === user._id && action === 'DELETED') {
          newUser.status = action;
        }
        return newUser;
      });
      dispatch(getUserSuccess(newUsersList));
      dispatch(routerActions.push(USERS));
    })
    .catch((error) => dispatch(showError(error)))
    .finally(() => dispatch(commonActions.hideLoading()));
};

export const showLoading = () => ({
  type: actionTypes.SHOW_LOADING_USERS,
});
export const getUserSuccess = (users) => ({
  type: actionTypes.GET_USERS_SUCCESS,
  payload: users,
});
export const getUserError = (error) => ({
  type: actionTypes.GET_USERS_ERROR,
  payload: error,
});
export const deleteUserSuccess = (users) => ({
  type: actionTypes.DELETE_USER_SUCCESS,
  payload: users,
});
export const deleteUserError = (error) => ({
  type: actionTypes.DELETE_USER_ERROR,
  payload: error,
});
export const setUserSelected = (user) => ({
  type: actionTypes.SET_USER_SELECTED,
  payload: user,
});

export const setFilter = ({ searchName, selectedRol }) => ({
  type: actionTypes.USERS_SET_FILTER,
  payload: { searchName, selectedRol },
});

export const changeFilter = (newFilter) => (dispatch, getState) => {
  const {
    users: { filter },
  } = getState();

  dispatch(setFilter({ ...filter, ...newFilter }));
};

export const resetFilter = () => ({
  type: actionTypes.USERS_RESET_FILTER,
});

export const inviteUser = (userInviteData) => (dispatch) => {
  dispatch(commonActions.showLoading());
  const data = {
    doc_type: userInviteData.doc_type,
    doc_number: userInviteData.doc_number,
    email: userInviteData.email,
    first_name: userInviteData.first_name,
    last_name: `${userInviteData.patern_last} ${userInviteData.matern_last}`.trim(),
    phones: [parsePhoneObject(userInviteData.phone_number, userInviteData.country_code)],
    roles: userInviteData.roles,
    matern_last: userInviteData.matern_last,
    patern_last: userInviteData.patern_last,
  };
  return usersService
    .createUser(data)
    .then((res) => {
      setTimeout(() => {
        dispatch(
          showError({
            ...successResponsive('Invitación enviada'),
            data: res.token,
          })
        );
      }, 0);
      dispatch(routerActions.push(USERS));
    })
    .catch((error) => {
      if (error.message === MSJ_ERROR_EMAIL_AGE) {
        dispatch(
          routerActions.push(USER_INVITE_FORM, { errorEmailAge: true, dataUser: userInviteData })
        );
      } else {
        dispatch(loggedActions.showError(error));
      }
    })
    .finally(() => dispatch(commonActions.hideLoading()));
};

export const update = (newData) => (dispatch, getState) => {
  dispatch(commonActions.showLoading());
  const { selected } = getState().users;
  const {
    _id: id_user,
    first_name,
    last_name,
    patern_last,
    matern_last,
    doc_type,
    doc_number,
  } = selected;
  return usersService
    .update({
      id_user,
      first_name,
      last_name,
      patern_last,
      matern_last,
      doc_type,
      doc_number,
      ...newData,
    })
    .then((payload) => dispatch(updateSuccess(payload)))
    .catch((error) => dispatch(commonActions.showError(error)))
    .finally(() => dispatch(commonActions.hideLoading()));
};

export const updateSuccess = (user) => (dispatch) => {
  dispatch(setUserSelected(user));
  dispatch(routerActions.push(USER_DETAIL));
  dispatch(loggedActions.showError(successResponsive(i18n.t('common.editSuccess'))));
};

export const updatePhone = (phone) => (dispatch, getState) => {
  dispatch(showLoading());
  dispatch(commonActions.showLoading());
  const { selected } = getState().users;
  const { _id: id_user } = selected;
  return usersService
    .updatePhone({ phone, id_user })
    .then((payload) => dispatch(updateSuccess(payload)))
    .catch((error) => dispatch(commonActions.showError(error)))
    .finally(() => dispatch(commonActions.hideLoading()));
};

export const setLegalAgent = (legalAgentUser) => ({
  type: actionTypes.SET_LEGAL_AGENT_USER,
  payload: legalAgentUser,
});

export const setPhoneUserSelected = (phone) => ({
  type: actionTypes.SET_PHONE_USER_SELECTED,
  payload: phone,
});

export const getOpscoreSuccess = (opscore) => ({
  type: actionTypes.GET_OPSCORE_SUCCESS,
  payload: opscore,
});

export const getOpscoreError = (error) => ({
  type: actionTypes.GET_OPSCORE_ERROR,
  payload: error,
});

export const getOpscore = (sellerId) => (dispatch) =>
  usersService
    .getOpscore(sellerId)
    .then((response) => {
      dispatch(getOpscoreSuccess(response));
    })
    .catch((error) => dispatch(getOpscoreError(error)));
